// extracted by mini-css-extract-plugin
export default {"card":"L2-z"};